// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".DeviceCode-module-deviceCodeContainer-4RXAR{flex-grow:1}@media(min-width: 960px){.DeviceCode-module-deviceCodeContainer-4RXAR{max-width:290px}}.DeviceCode-module-deviceCodeFieldWrapper-sZJOR{display:flex;flex-direction:column}.DeviceCode-module-inputWrapper-qgXJe{margin-top:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"deviceCodeContainer": "DeviceCode-module-deviceCodeContainer-4RXAR",
	"deviceCodeFieldWrapper": "DeviceCode-module-deviceCodeFieldWrapper-sZJOR",
	"inputWrapper": "DeviceCode-module-inputWrapper-qgXJe"
};
export default ___CSS_LOADER_EXPORT___;
